<!--选中充电桩-->
<template>
    <div>
        <el-select
            v-model="selectPile"
            filterable
            placeholder="充电桩"
            clearable
            @change="choosePile"
            :multiple="multiple"
            :style="{ width }"
            collapse-tags
            no-data-text="请先选择充电站"
            default-first-option
            :size="size"
        >
            <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.label"
                :value="item.id"
            ></el-option>
        </el-select>
    </div>
</template>
<script>
import util from "@/util";
import store from "@/store";
import Public from "@/public";
import { mapState } from "vuex";
export default {
    data() {
        return {
            options: [
                // {
                //     id: 1,
                //     label: '一号桩',
                // },
                // {
                //     id: 2,
                //     label: '二号桩',
                // },
                // {
                //     id: 3,
                //     label: '三号桩',
                // },
                // {
                //     id: 4,
                //     label: '四号桩',
                // },
                // {
                //     id: 5,
                //     label: '五号桩',
                // },
            ],
            selectPile: null, //选中的充电桩
        };
    },
    props: {
        siteId: null,
        multiple: Boolean,
        width: String,
        pileId: null,
        size: String, //尺寸
    },
    async mounted() {
        if (this.pileId) {
            this.selectPile = this.pileId;
        }
        await this.getData();
    },
    watch: {
        siteId: {
            handler(val) {
                this.getData();
                this.selectPile = null;
            },
            deep: true,
        },
        pileId: {
            handler(val) {
                this.selectPile = val;
            },
            deep: true,
        },
    },
    computed: {
        ...mapState(["equipmentInfo"]),
    },
    methods: {
        async getData() {
            if (!this.siteId) {
                return;
            }
            let postData = {
                station_id: this.siteId,
            };
            await store.dispatch("getEquipment", postData);
            let arrs = [];
            this.equipmentInfo.sort(Public.createComprisonFunction("cec_equipment_id"));
            for (let i = 0; i < this.equipmentInfo.length; i++) {
                let arr = {
                    id: this.equipmentInfo[i].id,
                    label: this.equipmentInfo[i].name,
                    cec_equipment_id: this.equipmentInfo[i].cec_equipment_id,
                };
                arrs.push(arr);
            }
            if (this.multiple) {
                arrs.unshift({ id: "all", label: "全选" });
            }
            this.options = JSON.parse(JSON.stringify(arrs));
        },
        /*选择充电桩*/
        choosePile(e) {
            if (this.multiple && e.includes("all")) {
                let data = JSON.parse(JSON.stringify(this.options));
                let arrs = data.slice(1);
                let idArrs = [];
                for (let i = 0; i < arrs.length; i++) {
                    idArrs.push(arrs[i].id);
                }
                // console.log(idArrs);
                // this.selectPile = idArrs;
                // let ids = [];
                // if (this.selectPile.length == this.options.length - 1) {
                //     ids = [];
                // } else {
                //     ids = JSON.parse(JSON.stringify(this.selectPile));
                // }
                // console.log(ids);
                console.log(idArrs);
                this.$emit("choose", idArrs);
            } else {
                this.$emit("choose", e);
            }
        },
    },
};
</script>
